// ʕ•ᴥ•ʔ

$(document).ready(function() {
  function reloadProductGrid(tagValue, $el) {
    var $filterToClick = $(`details.facets__disclosure-vertical ul li input[value="${tagValue}"]`);
    var $filterToClickParent = $filterToClick.parent();
    var atribute = $filterToClick.attr('checked');

    if ($filterToClickParent) {
      if (typeof atribute !== 'undefined' && atribute !== false) {
        $el.removeClass('active');
      } else {
        $el.addClass('active');
      }
      $filterToClickParent.click();
    }
  };

  function syncTags() {
    $('details.facets__disclosure-vertical ul li input[checked]').each(function() {
      $(`.icon__tag[href="${$( this ).val()}"]`).addClass('active');
    });
  }

  function displayTags() {
    $('details.facets__disclosure-vertical ul li input').each(function() {
      $(`.icon__tag[href="${$( this ).val()}"]`).removeClass('hidden');
    });
  }

  function hideActiveFacet() {
    var matchedFacets = [];
    $('.tag_link__buttons a.icon__tag').not('.hidden').each(function() {
      var tagValue = $(this).attr('href');
      var $matchingInput = $(`details.facets__disclosure-vertical ul li input[value="${tagValue}"]`);
      if ($matchingInput.length) {
        var $facetGroup = $matchingInput.closest('details.facets__disclosure-vertical');
        if ($facetGroup.length && matchedFacets.indexOf($facetGroup[0]) === -1) {
          matchedFacets.push($facetGroup[0]);
        }
      }
    });
    $(matchedFacets).hide();
  }

  // Click event for <a> tags
  $('.tag_link__buttons a.icon__tag').click(function(event) {
    var $tagButtonsContainer = $(this).parent();
    event.preventDefault(); // Prevent default link behavior
    $(this).parent().addClass('disabled');
    
    // Get the URL from the href attribute of the clicked <a> tag
    var url = $(this).attr('href');
    
    
    // Call the reloadProductGrid function with the URL
    try {
      reloadProductGrid(url, $(this));
      setTimeout(function(){
        $tagButtonsContainer.removeClass('disabled');
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  });

  displayTags();
  syncTags();
  hideActiveFacet();
});